<template lang="html">
  <d-form>
    <d-form-row>
      <d-col md="12" class="form-group">
        <label>{{label}}</label>
        <ul class="list-inline">
          <li v-for="(item, index) in list" :key="index" :class="[!item.selected ? 'no-content' : '', 'contract-detail text-left d-flex pr-3']">
            <d-checkbox
              toggle
              @change="toggleItem(item)"
              :checked="item.selected"
              class="custom-toggle-sm w-100"
            >
              <div v-html="item.name" v-if="item.name"></div>
              <div class="no-content text-left" v-else>{{ item.description }} (sem cláusula)</div>
            </d-checkbox>
            <i class="fas fa-edit" @click="editDetail(item)"></i>
          </li>
        </ul>
      </d-col>
    </d-form-row>
  </d-form>
</template>

<script>
import { mapActions } from 'vuex';
import Events from '_utils/events';
import { MODEL_EDITOR_TEXT, _OPEN_EDITOR_TEXT_MODAL_ } from './QuotationModel';

export default {
  name: 'contract-detail-list',
  props: {
    list: {
      type: Array,
      default: () => [{ ...MODEL_EDITOR_TEXT }],
    },
    type: {
      type: String,
    },
    label: {
      type: String,
      default: 'Obrigações',
    },
    quotationId: {
      type: Number,
    },
  },
  methods: {
    ...mapActions([
      'setToggle',
    ]),
    toggleItem(item) {
      item.selected = !item.selected;
    },
    editDetail(item) {
      this.setToggle({ type: 'edit_editor_text_modal', bool: true });
      Events.$emit(_OPEN_EDITOR_TEXT_MODAL_, { item, type: this.type });
    },
  },
};
</script>

<style lang="scss" scoped>
.contract-detail {
  .custom-toggle-sm {
    align-items: center;
    vertical-align: middle;
  }
  ::v-deep  .custom-control-description div {
    margin-top: -23px;
  }
  ::v-deep  .custom-control-description p {
    margin-bottom: 0;
  }
}
</style>
